<template>
  <div :class="{ mobile }" class="bonuses" data-t="header-bonuses">
    <StCounter
      v-if="counter"
      :size="mobile ? 's' : 'xs'"
      bg-color="orange"
      class="counter"
      data-t="header-counter"
      :label="counter"
    />
    <div class="header-bonuses">
      <div class="background">
        <AnimatedGift :isTMA="isTelegramMiniApp" class="bonuses-prize" />
      </div>
      <div class="bonuses-animation" />
    </div>
  </div>
</template>

<script setup lang="ts">
const { isTelegramMiniApp } = useTelegram()

withDefaults(
  defineProps<{
    mobile?: boolean
    counter: number
  }>(),
  {
    mobile: false,
  },
)
</script>

<style scoped>
@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

.bonuses {
  cursor: pointer;
  position: relative;
  width: 40px;
  height: 40px;
}

.header-bonuses {
  position: relative;

  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;

  background-color: transparent;
  border-radius: var(--border-radius-100);

  padding: 0.5px; /* stylelint-disable-line  */
}

.bonuses-animation {
  position: absolute;
  transform-origin: center;

  width: 70px;
  height: 70px;

  opacity: 0.9;
  background: linear-gradient(
    rgb(255 255 255 / 0%) 40%,
    rgb(197 146 133 / 100%) 100%
  );

  animation: spin 4s linear infinite;
}

.bonuses-prize {
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  border-radius: var(--border-radius-100);
}

.background {
  position: relative;
  z-index: 2;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;

  background: linear-gradient(225deg, #543c35, #563e38);
  border-radius: var(--border-radius-100);
}

.counter {
  position: absolute;
  z-index: 3;
  top: -6px;
  right: -6px;

  display: flex;
  align-items: center;
  justify-content: center;

  border: 1.5px solid var(--background-base);
}

.mobile {
  &.bonuses {
    width: 32px;
    height: 32px;
    margin-left: var(--spacing-100);
  }

  .counter {
    right: -13px;
    min-width: 23px !important;
  }

  .bonuses-animation {
    width: 40px;
    height: 40px;
  }

  .bonuses-prize {
    width: 35px;
  }
}
</style>
